import { useViewerCanAccessAnalyticsAdminSettings } from './selectors';

type UseShowAnalyticsSettings = () => boolean;
export const useShowAnalyticsSettings: UseShowAnalyticsSettings = () => {
  const isViewerCanAccessAnalyticsAdminSettings = useViewerCanAccessAnalyticsAdminSettings();

  return isViewerCanAccessAnalyticsAdminSettings;
};
